import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState, actions } from "../../state/reducer";
import {
  FunnelDisplayConfig,
  FunnelTemplate,
  UserShortInfo,
} from "../../types";
import {
  CheckboxInput,
  FormRow,
  GroupSelect,
  ManSelector,
  SelectInput,
  SelectOption,
} from "../components";

interface ModalProps {
  onSave: () => void;
  closeModal: () => void;
}

// "funnel" | "column" | "round"

const templates: SelectOption[] = [
  {
    value: "funnel",
    label: "Воронка",
  },
  {
    value: "column",
    label: "Колонки",
  },
  {
    value: "round",
    label: "Куговая",
  },
];

const SelectFunnelTemplateModal: React.FC<ModalProps> = ({
  onSave,
  closeModal,
}) => {
  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch();
  const [config, setConfig] = useState<FunnelDisplayConfig>({
    template: "funnel",
  });

  useEffect(() => {
    setConfig(State.statsTemplateConfig);
  }, []);

  const closeWithSave = () => {
    dispatch(actions.statsTemplateConfig(config));
    onSave();
    closeModal();
  };

  return (
    <div className="creationForm">
      <div className="modalHeading">
        <h3>Настройка отображения данных</h3>
      </div>
      <form className="columnCenter">
        <SelectInput
          label="Шаблон заполнения"
          options={templates}
          value={config.template}
          onChange={(event) =>
            setConfig((config) => ({
              ...config,
              template: event.target.value as FunnelTemplate,
            }))
          }
        />

        <CheckboxInput
          checked={!!config.combinePractice}
          label={"Собрать практики в одно событие"}
          onChange={(e) =>
            setConfig((config) => ({
              ...config,
              combinePractice: e.target.checked,
            }))
          }
        />

        {/* Кнопки действий */}
        <div className="flex between btnRow">
          <button
            className="filterButton"
            type="button"
            onClick={closeWithSave}
          >
            Применить
          </button>
          <button className="cancelButton" type="button" onClick={closeModal}>
            Отменить
          </button>
        </div>
      </form>
    </div>
  );
};

export default SelectFunnelTemplateModal;
